"use client";

import { c as _c } from "react-compiler-runtime";
import { motion } from "motion/react";
type ProfileDirectionArrowProps = {
  direction: "left" | "right";
  isAligned: boolean;
};
export function ProfileDirectionArrow(t0) {
  const $ = _c(18);
  const {
    direction,
    isAligned
  } = t0;
  let t1;
  if ($[0] !== direction || $[1] !== isAligned) {
    t1 = isAligned ? 0 : direction === "right" ? [0, 6, 0] : [0, -6, 0];
    $[0] = direction;
    $[1] = isAligned;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const t2 = isAligned ? 0.5 : 1;
  let t3;
  if ($[3] !== t1 || $[4] !== t2) {
    t3 = {
      x: t1,
      opacity: t2
    };
    $[3] = t1;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== isAligned) {
    t4 = isAligned ? {
      duration: 0.3
    } : {
      duration: 1.2,
      repeat: Infinity,
      ease: "easeInOut"
    };
    $[6] = isAligned;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== direction) {
    t5 = direction === "left" && <svg aria-hidden={true} className="h-5 w-5 text-white/80" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" viewBox="0 0 24 24"><path d="m15 18-6-6 6-6" /></svg>;
    $[8] = direction;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <svg aria-hidden={true} className="h-8 w-8 text-white/60" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" viewBox="0 0 24 24"><circle cx="12" cy="8" r="5" /><path d="M20 21a8 8 0 0 0-16 0" /></svg>;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== direction) {
    t7 = direction === "right" && <svg aria-hidden={true} className="h-5 w-5 text-white/80" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" viewBox="0 0 24 24"><path d="m9 18 6-6-6-6" /></svg>;
    $[11] = direction;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== t3 || $[14] !== t4 || $[15] !== t5 || $[16] !== t7) {
    t8 = <motion.div animate={t3} className="flex items-center gap-2" transition={t4}>{t5}{t6}{t7}</motion.div>;
    $[13] = t3;
    $[14] = t4;
    $[15] = t5;
    $[16] = t7;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  return t8;
}